import { useEffect, useRef, useState } from 'react';

export function useScrollDirection(element = window) {
    const prevScrollY = useRef(0);
    const [goingUp, setGoingUp] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);

    const handleScroll = () => {
        const currentScrollY = element.scrollTop;
        setScrollTop(currentScrollY);
        if (prevScrollY.current < currentScrollY && goingUp) {
            setGoingUp(false);
        }
        if (prevScrollY.current > currentScrollY && !goingUp) {
            setGoingUp(true);
        }
        prevScrollY.current = currentScrollY;
    };

    useEffect(() => {
        element.addEventListener("scroll", handleScroll);
        return () => element.removeEventListener("scroll", handleScroll);
    }, [goingUp, scrollTop]);

    return {
        direction: goingUp ? 'up' : 'down',
        scrollTop: scrollTop
    }
}